import { render, staticRenderFns } from "./ratingModelConfiguration.vue?vue&type=template&id=4588c13e&scoped=true"
import script from "./ratingModelConfiguration.vue?vue&type=script&lang=js"
export * from "./ratingModelConfiguration.vue?vue&type=script&lang=js"
import style0 from "./ratingModelConfiguration.vue?vue&type=style&index=0&id=4588c13e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4588c13e",
  null
  
)

export default component.exports